import(/* webpackMode: "eager", webpackExports: ["HomeLayout"] */ "/vercel/path0/src/components/Layouts/HomeLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LootBoxes"] */ "/vercel/path0/src/components/LootBoxes/index.tsx");
